<script>
import * as d3Select from 'd3-selection'
import * as d3Zoom from 'd3-zoom'
import * as d3 from 'd3'
import * as R from 'ramda'
import _ from 'underscore'

import { mapGetters } from 'vuex'

import CONSTANT from '../../../constant/preorder'
import SCHEDULECONSTANT from '../../../constant/schedule'
import Seats from './seats'

// import eruda from '../../../components/eruda.vue'

let seatingChartContext = null
let seatingChartContextWrap = null
let zoomInstance = null
let screenCtx = null
let axionYCtx = null

const SEAT_DEFAULT_WIDTH = 25
const SEAT_DEFAULT_HEIGHT = 25
const SCREEN_DEFAULT_HEIGHT = 70
const DEFAULT_MARGIN_BOTTOM = 95
const DEFAULT_MARGIN_TOP = 118
const MAXSCALE = 1.5
const AXION_MIDDLE_WIDTH = 194

const diff = (a, b) => {
  return b - a
}
export default {
  props: {
    isMinimap: Boolean,
    isResetSeats: Boolean,
    authType: Number,
    id: [String, Number],
  },
  data() {
    return {
      seatingChartStyle: {
        height: '275px',
        width: '650px',
      },
      wrapperStyle: {
        // height: '100vh'
      },
      axionYNames: [],
      axionMiddleHeight: '',
      scheduleSeats: [],
      isShowChart: false,
      sStyle: {},
    }
  },
  computed: {
    ...mapGetters(['getScheduleDetailById']),
    seatingChart() {
      return this.$store.state.schedule.seatingChart
    },
    screenName() {
      return R.path(['hall', 'name'], this.getScheduleDetailById(this.id)) || '' + '屏幕'
    },
    seatingChartTransform() {
      return this.$store.state.schedule.seatingChartTransform
    },
  },
  watch: {
    seatingChart(nv, ov) {
      setTimeout(() => {
        this.initChartData()
      }, 5)
    },
  },
  components: {
    Seats,
    // eruda,
  },
  methods: {
    zoomed(e) {
      if (!d3.event) {
        return
      }

      this.onSeatChartChange(d3.event.transform)

      seatingChartContext.style('transform', 'translate(' + d3.event.transform.x + 'px,' + d3.event.transform.y + 'px) scale(' + d3.event.transform.k + ')')
      seatingChartContext.style(
        '-webkit-transform',
        'translate(' + d3.event.transform.x + 'px,' + d3.event.transform.y + 'px) scale(' + d3.event.transform.k + ')',
      )

      if (d3.event.transform.k > MAXSCALE) {
        let x = d3.event.transform.x
        screenCtx.style('transform', `scale(${MAXSCALE})`)
        screenCtx.style('-webkit-transform', `scale(${MAXSCALE})`)
      } else {
        screenCtx.style('transform', `scale(${d3.event.transform.k})`)
        screenCtx.style('-webkit-transform', `scale(${d3.event.transform.k})`)
      }
      axionYCtx.style('transform', `translateY(${d3.event.transform.y}px) scale(1, ${d3.event.transform.k})`)
      axionYCtx.style('-webkit-transform', `translateY(${d3.event.transform.y}px) scale(1, ${d3.event.transform.k})`)

      this.$nextTick(() => {
        var domArr = document.querySelectorAll('.axion-middle')
        var x = 0
        if (domArr.length > 1) {
          x = domArr[1].getBoundingClientRect().x || domArr[1].getBoundingClientRect().left
        } else {
          x = domArr[0].getBoundingClientRect().x || domArr[0].getBoundingClientRect().left
        }
        this.sStyle = {
          left: x - ((this.seatingChartTransform.k > MAXSCALE ? MAXSCALE : this.seatingChartTransform.k) * AXION_MIDDLE_WIDTH) / 2 + 'px',
        }
        const scaleX = this.seatingChartTransform.k
        const targetEls = axionYCtx._groups[0][0].children || []
        for (let index = 0; index < targetEls.length; index++) {
          const element = targetEls[index]
          if (scaleX > 1) {
            element.style.transform = `scale(1, 0.5)`
          } else {
            element.style.transform = `scale(${scaleX})`
          }
        }
      })
    },
    handleZoomSeat(seat, event) {
      const transform = d3.zoomTransform(seatingChartContextWrap.node())
      if (transform.k >= 2) {
        return
      }
      const event2 = new MouseEvent('dblclick', {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: event.x,
        clientY: event.y,
      })
      event.srcElement.dispatchEvent(event2)
      setTimeout(() => {
        const transformed = d3.zoomTransform(seatingChartContextWrap.node())
        this.onSeatChartChange(transformed)
      }, 10)
      return
    },
    commitTransformInfo() {
      return _.throttle(this.$store.commit(SCHEDULECONSTANT.SCHEDULE_SET_SEATING_CHART_TRANSFORM, t), 500)
    },
    onSeatChartChange: _.throttle(function(t) {
      this.$store.commit(SCHEDULECONSTANT.SCHEDULE_SET_SEATING_CHART_TRANSFORM, t)
    }, 300),
    initChartData() {
      R.isEmpty(this.seatingChart) ? (this.isShowChart = false) : (this.isShowChart = true)

      const width = this.seatingChart.width
      const height = this.seatingChart.height
      const chartWidth = width * SEAT_DEFAULT_WIDTH
      const chartHeight = height * SEAT_DEFAULT_HEIGHT
      let wrapperWidth = document.body.clientWidth
      let left = !this.isMinimap ? (chartWidth > wrapperWidth ? -(chartWidth - wrapperWidth) / 2 : 0) : 0
      this.seatingChartStyle = {
        // left: left + 'px',
        width: chartWidth + 'px',
        height: chartHeight + SCREEN_DEFAULT_HEIGHT + 'px',
      }
      const currentK = window.innerWidth / chartWidth
      var t = d3.zoomIdentity.scale(currentK)
      zoomInstance.scaleExtent([currentK, 2])
      zoomInstance.transform(seatingChartContextWrap, t)

      // const wrapperOutterTop = document.querySelectorAll('.seating-chart-wrap')[1].offsetTop || 0
      // window.WW = document.querySelectorAll('.seating-chart-wrap')[1]

      //以下卖座1期注释掉的
      // const dom = document.querySelector('.app')
      // const wrapperHeight = document.body.scrollHeight - DEFAULT_MARGIN_TOP - DEFAULT_MARGIN_BOTTOM
      // console.log('wrapperHeight', wrapperHeight)
      // this.wrapperStyle = {
      //   height: wrapperHeight + 'px'
      // }

      /* 注释掉y坐标旧逻辑 */
      // this.axionMiddleHeight = chartHeight + 'px'
      // this.axionYNames = R.range(1, height + 1)

      /* y坐标新逻辑 , 长度加入过道*/
      let arr = []
      arr = R.keys(R.groupBy(n => n.rowNum, this.seatingChart.seats))
      arr.map((v, i) => {
        if (v != i + 1) {
          arr.splice(i, 0, '')
        }
      })
      this.axionYNames = arr
      this.axionMiddleHeight = arr.length * 25 + 'px'
      /* y坐标新逻辑 */

      // init seats data
      if (this.isResetSeats) {
        this.$store.commit(CONSTANT.PREORDER_RESET_SEATS)
      }
    },
  },
  mounted() {
    // seatingChartContext = d3Select.select(this.$refs['seating-chart'])
    screenCtx = d3Select.select(this.$refs['screen'])
    axionYCtx = d3Select.select(this.$refs['axion-y'])

    seatingChartContext = d3Select.select(this.$refs['map'])
    seatingChartContextWrap = d3Select.select(this.$refs['seating-chart-wrap'])
    zoomInstance = d3Zoom
      .zoom()
      .scaleExtent([1 / 2, 2])
      .on('zoom', this.zoomed)
    seatingChartContextWrap.call(zoomInstance)
  },
}
</script>
<template>
  <div class="seating-chart-wrap" :style="wrapperStyle" ref="seating-chart-wrap" v-show="isShowChart">
    <div class="seating-chart" ref="seating-chart" :style="seatingChartStyle">
      <div class="screen" ref="screen" :style="sStyle">{{ screenName }}</div>
      <div class="axion-y" ref="axion-y">
        <div class="rowName" v-for="(i, index) in axionYNames" :style="{ margin: i ? '2.5px 0' : '0' }" :key="index">{{ i }}</div>
      </div>
      <div class="map" ref="map">
        <div class="axion-middle" ref="axion-middle" :style="{ height: axionMiddleHeight }"></div>
        <Seats :id="id" :authType="authType" @handleZoomSeat="handleZoomSeat"></Seats>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import '../../../../stylesheet/variable';

.seating-chart-wrap {
  width: 100%;
  height: calc(~'100vh - 45px - 118px');
  overflow-y: hidden;
  .seating-chart {
    position: relative;
    .screen {
      position: relative;
      z-index: 2;
      height: 20px;
      min-width: 190px;
      font-size: 11px;
      line-height: 20px;
      border-radius: 1px 1px 8px 8px;
      text-align: center;
      color: @white;
      background-color: #dbdbdb;
      transform-origin: 0 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .axion-middle {
      position: absolute;
      left: calc(~'50% + 1px');
      border-left: 1px dotted @lightSliver;
      z-index: 2;
      transform: scaleX(0.5);
    }
    .axion-y {
      position: absolute;
      width: 15px;
      left: 10px;
      top: 70px;
      z-index: 2;
      text-align: center;
      background-color: @darkGrey;
      opacity: 0.2;
      border-radius: 11.5px;
      color: @white;
      transform-origin: 0 0;

      .rowName {
        width: 100%;
        height: 20px;
        margin: 2.5px 0;
        display: inline-block;
      }
    }
    .map {
      position: absolute;
      bottom: 95px;
      top: 70px;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      transform-origin: 0 0;
    }
  }
}
</style>
